export enum EmailNotificationsType {
  UPON_RECEIPT = 'uponReceipt',
  SUMMARIZED_DAILY = 'summarizedDaily',
  OPT_OUT_NOTIFICATIONS = 'optOutNotifications',
}
